import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"
import { useEffect } from "react"

const DatalayerButtonClick = props => {

  const datalayerButtonClickHandler = event => {
    let validClasses = ["ter-button", "t2-button", "t2-spbutton__wrap", "t2-search-button"]
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      let href = event.target.getAttribute("href") || null
      let classes = event.target.getAttribute("class")
      let currentPage = props?.location?.href
      let style = getComputedStyle(event.target)
      let bkg_color = style.backgroundColor || null
      let buttonType = null
      if (classes.includes("primary")) {
        buttonType = "primary"
      } else if (classes.includes("secondary")) {
        buttonType = "secondary"
      } else if (classes.includes("ter-bounded-card__link")) {
        buttonType = "secondary"
      } else if (classes.includes("t2-search-button")) {
        buttonType = "hero search"
      }

      let buttonText =
        event.target.textContent || event.target.innerText || null

      /* Check if Link Appears in a Card or not */
      let isInCard = false
      var element = event.target
      while (element.parentNode) {
        if (
          element.parentNode.className &&
          element.parentNode.className.includes("-card")
        ) {
          isInCard = true
        }
        element = element.parentNode
      }

      window.dataLayer.push({
        event: "button_click",
        component_name: buttonType, // specific button name, 'primary', 'secondary'
        component_type: "button", // 'button'
        component_background_color: bkg_color, //hex code of background color
        click_label: buttonText, //label of button text
        click_label_english: event?.target?.dataset?.englishTextLabel || null, // english label, queried separately on CTA Buttons
        click_url: href,
        click_within_card: isInCard, //if click is within a card layout, true|false
        click_helper_text: buttonText,
        content_date: null,
        content_type: null,
        content_heading: null,
        content_subheading: null,
        content_eyebrow: null,
        content_section: null,
        content_category: null,
        content_author: null,
        current_page: currentPage,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".ter-button, .t2-button, .t2-spbutton__wrap, .t2-search-button").length > 0
  }
  useClickListener(datalayerButtonClickHandler, query)
}

export default DatalayerButtonClick